import type { LayerKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import type {
  TreeLeafData,
  TreeNodeData,
} from '@festina-life/ui/listsAndTables'

import type { ConfigurationItem } from '../../types/common'

export type ConfigurationTreeLeaf = TreeLeafData & {
  blocks: string[]
  layer: LayerKey
  type: Exclude<ConfigurationItem, 'annulOperation'>
}

export const ConfigurationLeafTags = {
  draft: 'draft',
  extrinsic: 'extrinsic',
}

export type ActiveConfigurationItem = {
  layers: LayerKey[]
  packageName?: Optional<string>
  item: TreeNodeData<ConfigurationTreeLeaf> | ConfigurationTreeLeaf
}
